<template>
  <main class="dubai">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/dubai/2025/menu.vue';
import hero from '@/components/dubai/2025/hero.vue';
import agenda from '@/components/dubai/2025/agenda.vue';
import sponsors from '@/components/dubai/2025/sponsors.vue';
import speakers from '@/components/dubai/2025/speakers.vue';
import presenters from '@/components/dubai/2025/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .dubai {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>